import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeSubstring',
  standalone: true,
})
export class RemoveSubstringPipe implements PipeTransform {
  transform(value: string | undefined, substring: string): string {
    if (!value) {
      return '';
    }

    return value.replace(new RegExp(this.escapeRegExp(substring), 'g'), '');
  }

  private escapeRegExp(v: string): string {
    return v.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  }
}
